import { getManifest, loadRemoteModule } from '@angular-architects/module-federation';
import { Router, Routes } from '@angular/router';
import { CustomManifest } from './config';

export async function loadProjectModules(router: Router) {
    const manifest = getManifest<CustomManifest>();
    await buildProjectRoutes(manifest, router).then(routes => {
      router.resetConfig(routes);
      console.log('reset routes to', routes);
    });
  }

export function buildProjectRoutes(options: CustomManifest, router: Router): Promise<Routes> {
    return new Promise<Routes>(async (resolve, reject) => {
        // var projectRoutes: Routes = [];
            
        // await Promise.all(Object.keys(options).map(async key => {
        //     const entry = options[key];
        //     console.log(entry);
        //     projectRoutes.push({
        //         path: entry.routePath,
        //         loadChildren: () => loadRemoteModule({
        //                                 type: 'manifest',
        //                                 remoteName: key,
        //                                 exposedModule: entry.exposedModule
        //                             }).then(m => m[entry.ngModuleName])
        //     });
        // }));
        // const mainProjectRoute = router.config.find(_ => _.path == 'projects');
        // if (mainProjectRoute == null) { console.error('No project parent route was found'); return; }
        // mainProjectRoute.children = projectRoutes;
        resolve([...router.config]);
    });
}